module.exports = __webpack_public_path__ + "img/home.9e092eaa.jpg";